import React from "react";
import BaseInputWidget from "./BaseInputWidget";

const TimeWidget = props => {
  return <BaseInputWidget type="time" {...props} />;
};

export default TimeWidget;
